import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from './toggle';
import { SimpleFlexbox } from '../flexbox/flexbox';
import { Text } from '../text/text';
import styles from './compare_toggle.css';

const IconToggle = ({ icon, handleClick, isSelected, showLabel }) => (
    <Toggle className={styles.root} handleClick={handleClick}>
        <SimpleFlexbox display="flex" itemsCenter="xs" column>
            {icon}
            {showLabel && <Text size="small">{isSelected ? 'Selected' : 'Compare'}</Text>}
        </SimpleFlexbox>
    </Toggle>
);

IconToggle.propTypes = {
    showLabel: PropTypes.bool.isRequired,
    icon: PropTypes.element.isRequired,
    handleClick: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired
};

export { IconToggle };
